import { Protocol } from '../../Protocol';

export class AssignGroupProtocol {
  public static readonly GET_ASSIGN_GROUPS: string = `${Protocol.YATUNG_API_ROOT}/users/assigngroups/all`; // 取得指派群組清單
  public static readonly GET_PAGEABLE_ASSIGN_GROUPS: string = `${Protocol.YATUNG_API_ROOT}/users/assigngroups/pageable`; // 取得分頁指派群組清單
  public static readonly ASSIGN_GROUP_URL: string = `${Protocol.YATUNG_API_ROOT}/users/assigngroups`; // 指派群組清單通用url
}
